import { Col, Row, Image } from 'react-bootstrap';
import Default from './layout/Default';
import LoginImage from '../assets/images/login-img.png';
import ForgotPasswordForm from '../components/forgotPassword/ForgotPasswordForm';

const ForgotPassword = () => {

    return (
        <Default>
            <Row className="loginPage">
                <Col md="6" className='offset-md-1 mt-4'>
                <h2 className='text-center'><span>Welcome to </span><br/> Virtu Ward </h2>
                    <br></br>
                    <Image src={LoginImage} alt="" />
                </Col>
                <Col md="5" className='mt-md-4 mb-5'>
                    <ForgotPasswordForm />
                </Col>
            </Row>
        </Default>
    )
}

export default ForgotPassword;